export default __webpack_public_path__ + "static/satelliteleft-19c8fd3da25ad043b5b6e63246e5a0b4.png";